// Clinical posture syndrome definitions with plain-English labels + images
const ASSETS = "https://customer-assets-eiarnc6j.emergentagent.net/job_rehab-posture-ai/artifacts";

const IMG = {
  forward_head: `${ASSETS}/hq8dnq6y_Forward_Head.jpeg`,
  rounded_shoulders: `${ASSETS}/1t3t2x9z_Rounded_shoulder.webp`,
  thoracic_kyphosis: `${ASSETS}/78sk6cqe_Thoracic_Kyphosis.webp`,
  lumbar_lordosis: `${ASSETS}/8g34k9hl_Lumbar_Lordosis_.webp`,
  anterior_pelvic_tilt: `${ASSETS}/gvyzwpa4_Anterior_pelvic.webp`,
  flat_feet: `${ASSETS}/pez1vfoc_Flat_feet_bottom_view_2K_202608031152.webp`,
  knock_knees: `${ASSETS}/fgql2nkx_Legs_knees_.webp`,
  bow_legs: `${ASSETS}/zw9v97b1_Bow_legs_.webp`,
};

const TEST_IMG = {
  wall_occiput: `${ASSETS}/z3cd8ha9_wall%20occiput%20touch%20test.webp`,
  supine_shoulder_floor: `${ASSETS}/vqzvf3h4_rounded%20shoulder%20-%20supine%20shoulder%20floor%20contact%20ttest.webp`,
  wall_ribcage: `${ASSETS}/na707xjx_thoracic%20kyphosis%20-%20%20wall%20ribcage%20-%20head%20flat%20alignment%20test.webp`,
  supine_lumbar_gap: `${ASSETS}/gevtixx4_supine%20hand%20under%20lumbar%20gap%20test.webp`,
  ankle_touch_knee_gap: `${ASSETS}/z43ul5mi_bow%20legs%20%20%28genu%20varum%29%20-%20ankle%20touch%20knee%20gap%20test.webp`,
  asis_psis_beltline: `${ASSETS}/5hi4355b_anterior%20pelvic%20tilt%20test.webp`,
  wet_footprint: `${ASSETS}/s0d19tae_flat%20feet%20-%20wet%20footprint%20%26%20navicular%20hight%20check.webp`,
  knee_ankle_gap: `${ASSETS}/uwq58fru_knock%20kees%20assesment%20test.webp`,
};

// Muscle test images (3-panel: Strength Hold / Tightness Stretch / Spasm Palpation)
// Key MUST exactly match the anatomical name used in tight_muscles / weak_muscles arrays.
export const MUSCLE_TEST_IMG = {
  "Upper Trapezius": `${ASSETS}/jc0v8gbm_UPPER%20TRAPEZIUS%20%282%29.webp`,
  "Levator Scapulae": `${ASSETS}/c69ls9nx_levator%20scapulae.png`,
  "Suboccipitals": `${ASSETS}/l7u0taht_suboccipitals.webp`,
  "Sternocleidomastoid": `${ASSETS}/4c6mnly3_sternocleidomastoid.webp`,
  "Pectoralis Major/Minor": `${ASSETS}/mw2thdz9_Gemini_Generated_Image_tlkpi1tlkpi1tlkp.webp`,
  "Middle & Lower Trapezius": `${ASSETS}/h23wao3u_MIDDLE%20%26%20LOWER%20TRAPEZIUS.webp`,
  "Anterior Intercostals": `${ASSETS}/d4p8rbul_ANTERIOR%20INTERCOSTALS.webp`,
  "Subscapularis": `${ASSETS}/9rb6zvx7_SUBSCAPULARIS.webp`,
  "Latissimus Dorsi": `${ASSETS}/7dt99nqr_LATISSIMUS%20DORSI.webp`,
  "Rhomboids": `${ASSETS}/h6741ciw_ROMBOIDS.webp`,
  "Infraspinatus / Teres Minor": `${ASSETS}/t9fu7mci_INFRASPINATUS.png`,
  "Thoracic Erector Spinae": `${ASSETS}/sxw62u35_THORACIC%20ERECTOR%20SPINE.png`,
  "Rectus Abdominis": `${ASSETS}/jokorj24_RECTUS%20ABDOMINIS.png`,
  "Erector Spinae": `${ASSETS}/abn96h2g_ERECTORE%20SPINAE.png`,
  "Iliopsoas": `${ASSETS}/1u2l9yga_ILIOPSOAS.png`,
  "Hip Flexors": `${ASSETS}/1u2l9yga_ILIOPSOAS.png`,
  "Gluteus Maximus": `${ASSETS}/bg53sdl2_GLUTEUS%20MAXIMUS.png`,
  "Gluteus Medius": `${ASSETS}/trsascg8_GLUTEUS%20MEDIUS.png`,
  "Gluteus Medius / Maximus": `${ASSETS}/trsascg8_GLUTEUS%20MEDIUS.png`,
  "Piriformis": `${ASSETS}/8pre18uj_PIRIFORMIS.png`,
  "TFL": `${ASSETS}/c1xv6pzl_tensor%20faciale%20latae.png`,
  "Adductors": `${ASSETS}/81gpq7li_ADDUCTORS.png`,
  "Hamstrings": `${ASSETS}/z6p6922u_HAMSTRINNGS.png`,
  "Rectus Femoris": `${ASSETS}/2jmsysa7_RECTUS%20FEMORIS.png`,
  "Vastus Medialis": `${ASSETS}/dnl2v41v_VASTUS%20MEDIALIS.png`,
  "Vastus Lateralis": `${ASSETS}/jbj6sa0y_VASTUS%20LATERALIS.png`,
  "Peroneals": `${ASSETS}/g6docr7m_PERONEALS.png`,
  "Tibialis Posterior": `${ASSETS}/owou99qj_TIBIALIS%20POSTERIOR.png`,
  "Gastrocnemius (lateral)": `${ASSETS}/3hky5jmg_GASTROCNEMIUS.png`,
  "Intrinsic Foot Muscles": `${ASSETS}/0rswfsqq_INTRINSIC%20FOOT%20MUSCLE.png`,
};

// Per-muscle written instructions for each of the 3 activities (Strength / Tightness / Spasm).
// Shown below the muscle diagram in the assessment.
export const MUSCLE_TEST_STEPS = {
  "Upper Trapezius": {
    strength: "Sit upright. Shrug your shoulder up toward your ear while a friend gently pushes down against it. Hold 5–10 sec.",
    tightness: "Sit tall. Tilt your ear toward the opposite shoulder while holding the seat under you. Feel stretch on top of the neck (15–30 sec).",
    spasm: "Press the top of your shoulder halfway between the neck and the tip of the shoulder. Note any tender spot.",
  },
  "Levator Scapulae": {
    strength: "Sit tall. Look down and toward one armpit. Try to lift that shoulder while a friend resists. Hold 5–10 sec.",
    tightness: "Turn head toward opposite armpit, then look down. Same-side hand pulls head gently further. Feel stretch on back-side of neck (15–30 sec).",
    spasm: "Press just above the inner top corner of the shoulder blade — where neck meets shoulder. Look for tender knots.",
  },
  "Suboccipitals": {
    strength: "Lie on your back. Gently nod (chin tuck) without lifting head. Friend places 2 fingers under your chin and you resist. Hold 5–10 sec.",
    tightness: "Sit. Tuck your chin, then slowly lower it toward chest. Feel gentle pull at the base of the skull (15–30 sec).",
    spasm: "Fingertips at the base of the skull, just below the bump. Press gently on either side of the spine. Note tenderness.",
  },
  "Sternocleidomastoid": {
    strength: "Lie on your back. Lift head slightly and turn it to one side. Friend resists at your forehead. Hold 5–10 sec.",
    tightness: "Sit. Tilt ear toward one shoulder, then turn face up and away. Feel stretch on the front-side of the neck (15–30 sec).",
    spasm: "Feel the rope-like muscle from behind the ear to the collarbone. Gently pinch along its length — note tender spots.",
  },
  "Pectoralis Major/Minor": {
    strength: "Stand in a doorway, arm at 90°. Press forearm forward against the frame like a punch. Hold 5–10 sec.",
    tightness: "Stand in a doorway. Forearm on the frame at shoulder height. Step forward slowly. Feel stretch across the chest (15–30 sec).",
    spasm: "Press just below the collarbone and in front of the armpit. Note tender knots in the chest muscle.",
  },
  "Middle & Lower Trapezius": {
    strength: "Lie face-down, arms out to the side in a T. Squeeze shoulder blades together and lift arms slightly. Hold 5–10 sec.",
    tightness: "Usually weak, not tight. If it does pull, cross arms and hug shoulders, round upper back gently (15–30 sec).",
    spasm: "Press between the shoulder blades on either side of the spine. Note tender or knotty spots.",
  },
  "Rhomboids": {
    strength: "Lie face-down. Squeeze shoulder blades together (pinch a coin between them) and lift chest slightly. Hold 5–10 sec.",
    tightness: "Cross arms in front of chest, hug shoulders. Round the upper back gently. Feel stretch between shoulder blades (15–30 sec).",
    spasm: "Press about 2 fingers-width from the spine, between the shoulder blades. Note tenderness.",
  },
  "Latissimus Dorsi": {
    strength: "Stand tall. Pull elbows down and back toward hips against gentle resistance. Hold 5–10 sec.",
    tightness: "Kneel in front of a couch, arms straight on it. Sit hips back toward heels. Feel stretch under armpits and side of back (15–30 sec).",
    spasm: "Press along the side of the upper back below the armpit and above the waist. Note tender spots.",
  },
  "Subscapularis": {
    strength: "Elbow at side, bent 90°. Rotate forearm inward toward belly against gentle resistance. Hold 5–10 sec.",
    tightness: "Doorway stretch: forearm on frame, rotate torso away so palm turns outward. Feel stretch in front of shoulder (15–30 sec).",
    spasm: "In the armpit, reach fingers toward the shoulder blade from the front and gently press. Note tenderness (may be deep).",
  },
  "Infraspinatus / Teres Minor": {
    strength: "Elbow at side, bent 90°. Rotate forearm outward against gentle resistance. Hold 5–10 sec.",
    tightness: "Reach one arm across the chest, use other hand to pull it closer. Feel stretch in back of shoulder (15–30 sec).",
    spasm: "Press just below and behind the tip of the shoulder blade. Look for tender knots.",
  },
  "Anterior Intercostals": {
    strength: "Take a deep breath in, expanding the chest fully. Hold 5 sec, then exhale. Repeat 3 times.",
    tightness: "Sit tall, hands behind head. Gently lean upper body sideways. Feel stretch along the ribs (15–30 sec each side).",
    spasm: "Run fingertips along the gaps between the front ribs. Note tender or tight bands.",
  },
  "Thoracic Erector Spinae": {
    strength: "Lie face-down, hands by ears. Lift chest gently off the floor, keeping neck neutral. Hold 5–10 sec.",
    tightness: "Sit on the floor, legs crossed. Round upper back forward, chin to chest. Feel stretch along the mid-back (15–30 sec).",
    spasm: "Press along either side of the spine in the mid-back area. Note tender knots.",
  },
  "Rectus Abdominis": {
    strength: "Lie on back, knees bent. Lift head and shoulders slightly toward knees (small crunch). Hold 5–10 sec.",
    tightness: "Lie face-down, hands under shoulders. Gently press chest up (Cobra pose), hips on floor. Feel stretch in belly (15–30 sec).",
    spasm: "Press along the front of the belly, above and below the belly button. Note tender spots.",
  },
  "Erector Spinae": {
    strength: "Lie face-down. Lift chest and legs slightly off floor at the same time. Hold 5–10 sec.",
    tightness: "Lie on your back. Hug both knees to chest. Feel gentle stretch in lower back (15–30 sec).",
    spasm: "Press along either side of the spine in the lower back. Note any tender bands.",
  },
  "Iliopsoas": {
    strength: "Stand or sit. Lift knee toward chest against gentle resistance. Hold 5–10 sec.",
    tightness: "Kneel on one knee, other foot forward. Push hips forward gently, keep torso upright. Feel stretch in front of back hip (15–30 sec).",
    spasm: "Press just inside the front hip bone (2 fingers-width in). Gentle pressure — this muscle is deep.",
  },
  "Hip Flexors": {
    strength: "Stand or sit. Lift knee toward chest against gentle resistance. Hold 5–10 sec.",
    tightness: "Kneel on one knee, other foot forward. Push hips forward gently, keep torso upright. Feel stretch in front of back hip (15–30 sec).",
    spasm: "Press just inside the front hip bone (2 fingers-width in). Gentle pressure — this muscle is deep.",
  },
  "Gluteus Maximus": {
    strength: "Lie face-down. Squeeze one buttock and lift straight leg slightly. Hold 5–10 sec.",
    tightness: "Lie on back. Pull one knee across chest toward opposite shoulder. Feel stretch deep in the buttock (15–30 sec).",
    spasm: "Sit on a tennis ball placed under one buttock. Roll gently — note tender spots.",
  },
  "Gluteus Medius": {
    strength: "Lie on side. Lift the top leg straight up (keep hips stacked). Hold 5–10 sec.",
    tightness: "Sit cross-legged. Lean forward gently over the front knee. Feel stretch in side of hip (15–30 sec).",
    spasm: "Press just below the top of the hip bone, toward the outer buttock. Note tender knots.",
  },
  "Gluteus Medius / Maximus": {
    strength: "Lie face-down. Squeeze the buttock and lift a straight leg slightly. Then repeat on side, lifting the top leg. Hold each 5–10 sec.",
    tightness: "Lie on back, pull one knee across chest toward opposite shoulder. Feel deep buttock stretch (15–30 sec).",
    spasm: "Press across the entire buttock — top, middle, and outer areas. Note tender knots.",
  },
  "Piriformis": {
    strength: "Sit on a chair. Rotate the knee outward (foot toward inside) against gentle resistance. Hold 5–10 sec.",
    tightness: "Lie on back. Cross one ankle over opposite knee, pull bottom thigh toward chest. Feel deep stretch in buttock (15–30 sec).",
    spasm: "Press deep in the middle of the buttock (halfway between hip bone and sit bone). Note tender spots.",
  },
  "TFL": {
    strength: "Stand, cross tested leg behind, lean torso away to hold. Use hand to resist diagonal lift if needed. Hold 5–10 sec.",
    tightness: "Standing, cross tested leg behind. Shift hips sideways and away from the tested leg to increase stretch (15–30 sec).",
    spasm: "Use fingers to gently palpate deep tissues. Point: just below and in front of the top of the pelvic bone, front-outer hip.",
  },
  "Adductors": {
    strength: "Lying face-down, small controlled lift. Squeeze a cushion with knees. Hold 5–10 sec.",
    tightness: "Seated on floor, soles of feet together. Knees dropped outward and gently pressed down. Feel stretch (15–30 sec).",
    spasm: "Use fingers to gently palpate deep tissues. Point: marked on upper-inner thigh, close to groin. Gentle pressure.",
  },
  "Hamstrings": {
    strength: "Lying face-down, small controlled lift. Knee bent against hand resistance. Hold 5–10 sec.",
    tightness: "Standing, leg extended straight with heel on floor. Hinge forward at the hips, back flat. Feel stretch (15–30 sec).",
    spasm: "Use fingers to gently palpate deep tissues. Point: midpoint of the back of the thigh. Gentle pressure.",
  },
  "Rectus Femoris": {
    strength: "Standing, bend knee and extend hip slightly backward against resistance. Keep torso stable. Hold 5–10 sec.",
    tightness: "Standing, hold ankle behind body. Pull heel toward buttock, knee pointing down. Feel stretch (15–30 sec).",
    spasm: "Use fingers to palpate deep tissues. Point: midline of the front thigh, just above the kneecap.",
  },
  "Vastus Medialis": {
    strength: "Seated, leg extended straight, foot turned slightly outward. Tighten inner-front thigh against light resistance under the ankle. Hold 5–10 sec.",
    tightness: "Standing quad stretch — ankle held behind body, knee angled slightly outward to bias the inner thigh. Feel stretch (15–30 sec).",
    spasm: "Use fingers to palpate deep tissues. Point: inner-front thigh just above the inner side of the kneecap.",
  },
  "Vastus Lateralis": {
    strength: "Standing or seated. Foot turned inward. Contract outer thigh muscle against resistance. Hold 5–10 sec.",
    tightness: "Standing, ankle held behind body. Pull heel toward buttock, knee angled inward. Feel stretch (15–30 sec).",
    spasm: "Use fingertips to palpate the outer-lateral thigh band for trigger points. Mark: hand-width above the knee.",
  },
  "Peroneals": {
    strength: "Seated, foot dangling. Push the outer edge of the foot outward against resistance (a hand or wall). Hold 5–10 sec.",
    tightness: "Seated. Turn foot inward and point toes down. Feel stretch along the outer shin (15–30 sec).",
    spasm: "Press along the outer side of the shin, halfway between knee and ankle. Note tender spots.",
  },
  "Tibialis Posterior": {
    strength: "Seated, foot on floor. Try to lift the inner arch off the ground without curling the toes. Hold 5–10 sec.",
    tightness: "Sit with leg crossed. Turn the foot outward and point toes down. Feel gentle pull on the inner shin (15–30 sec).",
    spasm: "Press along the deep inner shin, behind the shin bone. Note tender spots (this muscle is deep).",
  },
  "Gastrocnemius (lateral)": {
    strength: "Stand facing a wall for balance. Rise up on your toes (both feet). Hold at the top for 5–10 sec. Repeat 10 times.",
    tightness: "Stand facing a wall, hands on wall. Step one foot back, heel on floor, knee straight. Feel stretch in the calf (15–30 sec).",
    spasm: "Squeeze the calf firmly with your fingers from behind the knee down to the ankle. Note tender spots or hard knots.",
  },
  "Intrinsic Foot Muscles": {
    strength: "Sit. Try to lift the arch of your foot off the floor without curling the toes or lifting heel / ball of foot. Hold 5–10 sec.",
    tightness: "Sit with one leg crossed. Gently pull toes upward and back while pressing thumb along the bottom of the foot. Feel stretch under the sole (15–30 sec).",
    spasm: "Press with your thumb along the sole of the foot — especially the arch and just behind the ball of the foot. Note tender points.",
  },
};

export const POSTURE_PATTERNS = [
  {
    id: "forward_head",
    name: "Forward Head Posture",
    plain_name: "Head Pokes Forward",
    region: "Neck",
    plain_region: "Neck",
    hint: "Text neck; head translated anterior to shoulders (CVA < 50°).",
    plain_hint: "Your ears sit in front of your shoulders when you stand relaxed — like your head is always leading the way.",
    image: IMG.forward_head,
    tight_muscles: [
      { name: "Upper Trapezius", plain: "top of shoulders / neck" },
      { name: "Levator Scapulae", plain: "side of the neck" },
      { name: "Suboccipitals", plain: "base of the skull" },
      { name: "Sternocleidomastoid", plain: "front-side of the neck" },
    ],
    weak_muscles: [
      { name: "Middle & Lower Trapezius", plain: "between shoulder blades" },
    ],
    self_test: {
      name: "Wall Occiput Touch Test",
      plain_name: "Can Your Head Touch The Wall?",
      test_image: TEST_IMG.wall_occiput,
      steps: [
        "Stand with heels, bottom, and upper back against a wall.",
        "Without lifting your chin, try to touch the back of your head to the wall.",
        "If there's a gap, measure it with your fingers (roughly, in cm).",
      ],
      threshold: "Gap > 0 cm = positive; > 4 cm = severe.",
      plain_threshold: "Any gap means your head sits too far forward. A gap wider than 4 fingers is a bigger deal.",
    },
  },
  {
    id: "rounded_shoulders",
    name: "Rounded Shoulders",
    plain_name: "Slouched Shoulders",
    region: "Shoulders",
    plain_region: "Shoulders",
    hint: "Scapulae protracted; humerus internally rotated.",
    plain_hint: "Your shoulders roll forward and inward — the classic desk-worker slump.",
    image: IMG.rounded_shoulders,
    tight_muscles: [
      { name: "Pectoralis Major/Minor", plain: "chest muscles" },
      { name: "Latissimus Dorsi", plain: "side of upper back" },
      { name: "Subscapularis", plain: "front of shoulder blade" },
    ],
    weak_muscles: [
      { name: "Middle & Lower Trapezius", plain: "between shoulder blades" },
      { name: "Rhomboids", plain: "upper back, between shoulder blades" },
      { name: "Infraspinatus / Teres Minor", plain: "back of shoulder (rotator cuff)" },
    ],
    self_test: {
      name: "Supine Shoulder-Floor Contact Test",
      plain_name: "Do Your Shoulders Touch The Floor?",
      test_image: TEST_IMG.supine_shoulder_floor,
      steps: [
        "Lie flat on your back on the floor, knees bent, arms at your sides.",
        "Relax completely — don't force anything.",
        "Notice: does the back of each shoulder rest flat on the floor?",
      ],
      threshold: "Any lift of the shoulder off floor = positive.",
      plain_threshold: "If one or both shoulders hover above the floor, they're rounded forward.",
    },
  },
  {
    id: "thoracic_kyphosis",
    name: "Thoracic Kyphosis",
    plain_name: "Hunched Upper Back",
    region: "Upper Back",
    plain_region: "Upper Back",
    hint: "Excessive upper-back convex curvature > 40°.",
    plain_hint: "Your upper back curves outward too much — you look hunched even when trying to stand tall.",
    image: IMG.thoracic_kyphosis,
    tight_muscles: [
      { name: "Pectorals", plain: "chest muscles" },
      { name: "Rectus Abdominis", plain: "front of the belly (six-pack)" },
      { name: "Anterior Intercostals", plain: "front of the ribcage" },
    ],
    weak_muscles: [
      { name: "Thoracic Erector Spinae", plain: "muscles along the upper back" },
      { name: "Middle Trapezius / Rhomboids", plain: "between the shoulder blades" },
    ],
    self_test: {
      name: "Wall Ribcage-Head Alignment Test",
      plain_name: "Can You Stand Flat Against A Wall?",
      test_image: TEST_IMG.wall_ribcage,
      steps: [
        "Stand with heels about 5 cm (2 inches) from a wall.",
        "Try to press your bottom, upper back, and head to the wall at the same time.",
        "If you can't get your upper back or head flat without straining — the hunch is showing.",
      ],
      threshold: "Visible curve with head unable to reach wall = positive.",
      plain_threshold: "If your upper back doesn't touch the wall easily, you have a hunch.",
    },
  },
  {
    id: "lumbar_lordosis",
    name: "Lumbar Lordosis",
    plain_name: "Deep Lower-Back Curve (Sway Back)",
    region: "Lower Back",
    plain_region: "Lower Back",
    hint: "Excessive lower-back anterior concavity.",
    plain_hint: "Your lower back curves inward too much — belly pushed forward, bottom sticking out.",
    image: IMG.lumbar_lordosis,
    tight_muscles: [
      { name: "Erector Spinae", plain: "long muscles running down the back" },
      { name: "Iliopsoas", plain: "deep front-hip / groin muscle" },
      { name: "Rectus Femoris", plain: "front of the thigh" },
    ],
    weak_muscles: [
      { name: "Rectus Abdominis", plain: "front of the belly" },
      { name: "Gluteus Maximus", plain: "bottom / buttock" },
      { name: "Hamstrings", plain: "back of the thighs" },
    ],
    self_test: {
      name: "Supine Hand-Under-Lumbar Gap Test",
      plain_name: "How Much Space Under Your Lower Back?",
      test_image: TEST_IMG.supine_lumbar_gap,
      steps: [
        "Lie flat on your back on the floor with legs straight.",
        "Slide your hand under the small of your back.",
        "Judge the space: flat palm fits (normal), fist fits (too much curve).",
      ],
      threshold: "Fist easily fits = positive.",
      plain_threshold: "If a full fist fits under your lower back, the curve is too deep.",
    },
  },
  {
    id: "anterior_pelvic_tilt",
    name: "Anterior Pelvic Tilt",
    plain_name: "Hips Tipped Forward",
    region: "Pelvis",
    plain_region: "Hips",
    hint: "ASIS drops below PSIS > 15°.",
    plain_hint: "Your hips tip forward like a bowl of water pouring out the front — makes your belly stick out and bottom stick back.",
    image: IMG.anterior_pelvic_tilt,
    tight_muscles: [
      { name: "Hip Flexors", plain: "front of the hips (top of the thigh)" },
      { name: "Erector Spinae", plain: "muscles down the lower back" },
    ],
    weak_muscles: [
      { name: "Gluteus Maximus", plain: "buttocks" },
      { name: "Abdominals", plain: "core / belly muscles" },
      { name: "Hamstrings", plain: "back of the thighs" },
    ],
    self_test: {
      name: "ASIS-PSIS Beltline Angle Test",
      plain_name: "Front Hip vs Back Hip",
      test_image: TEST_IMG.asis_psis_beltline,
      steps: [
        "Stand relaxed. Place your index fingers on the two front pointy hip bones.",
        "Place your thumbs on the two back pointy hip bones (dimples above the buttocks).",
        "See a mirror or take a side photo: is the front lower than the back?",
      ],
      threshold: "Any visible forward drop of ASIS > PSIS = positive.",
      plain_threshold: "If your front hip bones drop below your back hip bones, your hips are tipped forward.",
    },
  },
  {
    id: "flat_feet",
    name: "Flat Feet (Pes Planus)",
    plain_name: "Flat Feet / Fallen Arches",
    region: "Foot & Ankle",
    plain_region: "Feet",
    hint: "Medial arch collapse; navicular drop; heel eversion.",
    plain_hint: "The inner arch of your foot has collapsed — the whole sole touches the ground.",
    image: IMG.flat_feet,
    tight_muscles: [
      { name: "Peroneals", plain: "outer side of the shin" },
      { name: "Gastrocnemius (lateral)", plain: "outer calf" },
    ],
    weak_muscles: [
      { name: "Tibialis Posterior", plain: "deep inner shin (arch support)" },
      { name: "Intrinsic Foot Muscles", plain: "tiny muscles inside the foot" },
    ],
    self_test: {
      name: "Wet Footprint & Navicular Check",
      plain_name: "The Wet-Foot Test",
      test_image: TEST_IMG.wet_footprint,
      steps: [
        "Wet the bottom of both feet.",
        "Step onto a piece of paper or a dry stone tile.",
        "Look at the shape: a normal foot leaves a curved print with a gap on the inside. A flat foot leaves a solid oval — no gap.",
      ],
      threshold: "Drop > 10 mm = positive.",
      plain_threshold: "If your footprint has no arch gap on the inside, you have flat feet.",
    },
  },
  {
    id: "knock_knees",
    name: "Knock Knees (Genu Valgum)",
    plain_name: "Knees That Touch (Knock Knees)",
    region: "Legs / Knees",
    plain_region: "Legs",
    hint: "Medial knee convergence; ankles gap > 5 cm when knees touch.",
    plain_hint: "When you stand with your knees together, your ankles can't touch — there's a gap.",
    image: IMG.knock_knees,
    tight_muscles: [
      { name: "Adductors", plain: "inner thighs" },
      { name: "TFL", plain: "front-outer hip band" },
      { name: "Vastus Lateralis", plain: "outer front thigh" },
    ],
    weak_muscles: [
      { name: "Gluteus Medius / Maximus", plain: "side and back of the hip / buttock" },
      { name: "Vastus Medialis", plain: "inner-front thigh (VMO)" },
    ],
    self_test: {
      name: "Knee-Ankle Gap Measurement Test",
      plain_name: "Ankle Gap With Knees Together",
      test_image: TEST_IMG.knee_ankle_gap,
      steps: [
        "Stand upright with your knees lightly touching each other.",
        "Keep both feet pointing straight forward.",
        "Ask someone or use a ruler: measure the gap between your inner ankles.",
      ],
      threshold: "Gap > 5 cm = positive.",
      plain_threshold: "If your ankles are more than 2 fingers apart when your knees touch, you have knock knees.",
    },
  },
  {
    id: "bow_legs",
    name: "Bow Legs (Genu Varum)",
    plain_name: "Bowed-Out Legs",
    region: "Legs / Knees",
    plain_region: "Legs",
    hint: "Lateral tibial bowing; knee gap > 4 cm when ankles touch.",
    plain_hint: "When your ankles are together, your knees don't touch — like a cowboy stance.",
    image: IMG.bow_legs,
    tight_muscles: [
      { name: "TFL", plain: "front-outer hip band" },
      { name: "Vastus Lateralis", plain: "outer front thigh" },
      { name: "Piriformis", plain: "deep buttock rotator" },
    ],
    weak_muscles: [
      { name: "Adductors", plain: "inner thighs" },
      { name: "Gluteus Medius", plain: "side of the hip" },
      { name: "Vastus Medialis", plain: "inner-front thigh (VMO)" },
    ],
    self_test: {
      name: "Ankle-Touch Knee-Gap Test",
      plain_name: "Knee Gap With Ankles Together",
      test_image: TEST_IMG.ankle_touch_knee_gap,
      steps: [
        "Stand upright, feet and inner ankles touching each other.",
        "Keep feet flat and pointing forward.",
        "Measure the gap between your inner knees.",
      ],
      threshold: "Gap > 4 cm = positive.",
      plain_threshold: "If your knees stay more than 2 fingers apart when your ankles touch, your legs bow outward.",
    },
  },
];

export const getPatternById = (id) => POSTURE_PATTERNS.find((p) => p.id === id);
